
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first",
      function () {
        return require("private-next-pages/first.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first"])
      });
    }
  